import React, { useState } from 'react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { ChevronDown, ChevronUp } from 'lucide-react';

const ResearchSection = () => {
  const [expandedSection, setExpandedSection] = useState(null);

  const researchAreas = [
    {
      id: 1,
      title: 'Women Empowerment',
      description: 'Research on PCPNDT Act implementation, gender discrimination, and child sex ratio'
    },
    {
      id: 2,
      title: 'Child Development',
      description: 'Studies on child protection, education, legal frameworks, and child-friendly environments'
    },
    {
      id: 3,
      title: 'Food Security, Health & Nutrition',
      description: 'Research on traditional food practices, malnutrition, and public health services'
    },
    {
      id: 4,
      title: 'Livelihood Development',
      description: 'Assessment of skill gaps, employment opportunities, and youth development programs'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
            Research & Studies
          </h2>
          <div className="w-24 h-1 bg-orange-600 mx-auto mb-8"></div>
          <p className="text-gray-600 max-w-4xl mx-auto text-lg leading-relaxed">
            Researches and studies are very important parts of social work. They help us in understanding 
            the situation and designing our interventions accordingly. Prayatne has developed a dedicated 
            cell for this purpose which undertakes such researches by involving internal as well as external experts.
          </p>
        </div>

        <div className="max-w-4xl mx-auto space-y-4">
          {researchAreas.map((area) => (
            <Card
              key={area.id}
              className="border-none shadow-lg hover:shadow-xl transition-all duration-300"
            >
              <CardContent className="p-0">
                <button
                  onClick={() => setExpandedSection(expandedSection === area.id ? null : area.id)}
                  className="w-full p-6 flex items-center justify-between text-left hover:bg-gray-50 transition-colors duration-200"
                >
                  <div className="flex-1">
                    <h3 className="text-xl font-bold text-gray-800 mb-2">{area.title}</h3>
                    <p className="text-gray-600">{area.description}</p>
                  </div>
                  <div className="ml-4">
                    {expandedSection === area.id ? (
                      <ChevronUp className="text-orange-600" size={24} />
                    ) : (
                      <ChevronDown className="text-orange-600" size={24} />
                    )}
                  </div>
                </button>
                {expandedSection === area.id && (
                  <div className="px-6 pb-6 border-t">
                    <p className="text-gray-600 mt-4 leading-relaxed">
                      Detailed information about {area.title} research projects and findings. 
                      Our comprehensive studies have influenced policy changes and improved implementation 
                      of various schemes and programs.
                    </p>
                  </div>
                )}
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="text-center mt-12">
          <Button className="bg-orange-600 hover:bg-orange-700 text-white px-8 py-6 text-lg">
            View All Research
          </Button>
        </div>
      </div>
    </section>
  );
};

export default ResearchSection;